import QRCode from 'qrcode.react';
import { Box, Center, Divider, Group, Stack, Text } from 'ui';

import classes from './EventTicket.module.css';

interface TicketDetailsProps {
  ticketName: string;
  ticketId: string;
  ticketUrl: string;
}

const TicketDetails: React.FC<TicketDetailsProps> = ({ ticketName, ticketId, ticketUrl }) => {
  return (
    <Group className={classes.EventTicket__details}>
      <Box className={classes.EventTicket__cutout}>
        <Box className={classes.EventTicket__cutoutLeft}></Box>
        <Box className={classes.EventTicket__cutoutRight}></Box>
      </Box>
      <Center py="xs" flex={1}>
        <QRCode value={ticketUrl} id="qr-gen" size={107} />
      </Center>
      <Divider orientation="vertical" flex={0} />
      <Stack gap={14} flex={1}>
        <Stack gap={4}>
          <Text fz="xs" c="gray">
            Ticket Name
          </Text>
          <Text fz="xs">{ticketName}</Text>
        </Stack>
        <Stack gap={4}>
          <Text fz="xs" c="gray">
            Ticket ID
          </Text>
          <Text fz="xs">{ticketId}</Text>
        </Stack>
      </Stack>
    </Group>
  );
};

export { TicketDetails };
